import type {Calibration, InferenceApiResponse, MappedInference} from '@/types/inference';

const NO_USAGE_TIME = 'None';

const normalizeUsageTime = (value?: string) => (value === NO_USAGE_TIME ? undefined : value);

const normalizeCalibration = (calibration?: Calibration): Calibration =>
    ({
        ...calibration,
        first_usage_time: normalizeUsageTime(calibration?.first_usage_time),
        last_usage_time: normalizeUsageTime(calibration?.last_usage_time),
    }) as Calibration;

const experienceInferenceMapping = (response: unknown): MappedInference | null => {
    const {data} = (response as InferenceApiResponse) ?? {};
    const responseData = data?.[0];

    if (!responseData) return null;

    const {inferredOn, result} = responseData;
    const calibration = normalizeCalibration(result?.Calibration);
    const {n_sticks_identified, min_n_experiences_required} = calibration;

    if (n_sticks_identified < min_n_experiences_required) {
        return {
            inferenceTimestamp: inferredOn,
            calibration,
            experienceScore: null,
            tipsToConsider: null,
            insightsAndTips: null,
        };
    }

    const {tips_to_consider, ...experienceScoreData} = result?.experience_score ?? ({} as never);

    return {
        inferenceTimestamp: inferredOn,
        calibration,
        experienceScore: experienceScoreData,
        tipsToConsider: tips_to_consider ?? null,
        insightsAndTips: {
            ...result?.Insights,
            ...result?.TipsAndTricks,
        },
    };
};

export default experienceInferenceMapping;
